// GovBidIQ Academy — Phase 1 framework content (synthetic placeholders).
// All articles are stubs with deterministic structure so the LearningArticle
// page can render any of them. Real curriculum work is deferred per Phase 1 scope.

const stub = (title, summary, category, related = []) => ({
  slug: title.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, ""),
  title,
  summary,
  category,
  read_minutes: 5,        // 5-minute-read placeholder
  summary_minutes: 2,     // 2-minute summary placeholder
  video_placeholder: true,
  faq_placeholder: [
    { q: `What is ${title.toLowerCase()}?`, a: "TODO — placeholder answer." },
    { q: `Who needs to know about ${title.toLowerCase()}?`, a: "TODO — placeholder answer." },
    { q: `What is the most common mistake?`, a: "TODO — placeholder answer." },
  ],
  next_lesson_slug: null, // populated after build
  related,                // slugs
  body_sections: [
    { heading: "Overview", body: `Placeholder overview for ${title}. Real content forthcoming.` },
    { heading: "Why it matters", body: "TODO — placeholder paragraph explaining business impact." },
    { heading: "Key terms", body: "TODO — placeholder paragraph defining the core vocabulary." },
    { heading: "Common pitfalls", body: "TODO — placeholder paragraph on what new contractors get wrong." },
    { heading: "Next steps", body: "TODO — placeholder paragraph linking to deeper resources." },
  ],
});

export const CATEGORIES = [
  "Government Contracting Basics",
  "Bid/No-Bid Decisions",
  "Capture Management",
  "Proposal Development",
  "FAR Basics",
  "NAICS Codes",
  "SAM.gov Basics",
  "CPARS",
  "SDVOSB Strategy",
  "8(a) Strategy",
  "HUBZone Strategy",
  "WOSB Strategy",
  "Teaming Agreements",
  "Subcontracting Strategy",
  "Agency Buying Patterns",
  "Competitive Intelligence",
  "Market Research",
  "Pricing Strategy",
  "Proposal Compliance",
  "Contract Administration",
  "Federal Acquisition Lifecycle",
];

const RAW = [
  ["Government Contracting 101", "A plain-English orientation to how the federal government buys from contractors.", "Government Contracting Basics", ["far-101"]],
  ["The Bid/No-Bid Decision Framework", "A structured five-question framework to decide whether to pursue an opportunity.", "Bid/No-Bid Decisions", ["capture-fundamentals", "competitive-positioning"]],
  ["Capture Fundamentals", "From opportunity identification through proposal kickoff: the capture lifecycle in 20 minutes.", "Capture Management", ["the-bid-no-bid-decision-framework"]],
  ["Writing a Compliant Proposal", "Compliance is the floor, not the ceiling — how to never lose on technicalities.", "Proposal Development", ["proposal-compliance-checklists"]],
  ["FAR 101", "The Federal Acquisition Regulation in five paragraphs: what it is, why it matters, where to read it.", "FAR Basics", ["far-clause-cheat-sheet"]],
  ["NAICS Codes Explained", "How NAICS drives size standards, set-asides, and your competitive landscape.", "NAICS Codes", ["small-business-size-standards"]],
  ["SAM.gov for Beginners", "Registration, search, watchlists, and the three reports every contractor reads weekly.", "SAM.gov Basics", []],
  ["Reading and Responding to CPARS", "Past performance is a currency. Here is how to earn, read, and dispute it.", "CPARS", []],
  ["SDVOSB Strategy", "How service-disabled-veteran-owned firms win in DoD and VA — set-asides, sole-source, and pitfalls.", "SDVOSB Strategy", ["8a-strategy", "hubzone-strategy"]],
  ["8(a) Strategy", "The nine-year 8(a) ladder: the mentor-protégé play, sole-source ceilings, and graduation planning.", "8(a) Strategy", ["sdvosb-strategy"]],
  ["HUBZone Strategy", "Why geography matters, how the principal-office rule works, and how to keep certification.", "HUBZone Strategy", []],
  ["WOSB Strategy", "Economically disadvantaged WOSB vs. WOSB: which set-asides apply where.", "WOSB Strategy", []],
  ["Teaming Agreements", "Prime/sub teaming, joint ventures, and the seven clauses every TA must contain.", "Teaming Agreements", ["subcontracting-strategy"]],
  ["Subcontracting Strategy", "When to sub, when to prime, and how to use subcontracts to build past performance.", "Subcontracting Strategy", []],
  ["Agency Buying Patterns", "How to read an agency's recurring buys, year-end spend, and small-business goals.", "Agency Buying Patterns", []],
  ["Competitive Intelligence for Contractors", "Sources, signals, and synthesis — how to know who you are bidding against.", "Competitive Intelligence", []],
  ["Market Research for Federal Opportunities", "Quantitative + qualitative sources beyond SAM.gov.", "Market Research", []],
  ["Pricing Strategy", "Cost vs. price, LPTA vs. best-value, and how to read evaluation criteria as pricing guidance.", "Pricing Strategy", []],
  ["Proposal Compliance Checklists", "Section L / Section M cross-walks and how to instrument them.", "Proposal Compliance", []],
  ["Contract Administration", "Modifications, options, performance reporting — keeping the contract green.", "Contract Administration", []],
  ["The Federal Acquisition Lifecycle", "Pre-award → award → administration → close-out: every stage in one diagram.", "Federal Acquisition Lifecycle", []],
];

export const ARTICLES = RAW.map(([t, s, c, r]) => stub(t, s, c, r));
ARTICLES.forEach((a, i) => { a.next_lesson_slug = ARTICLES[(i + 1) % ARTICLES.length].slug; });

export const findBySlug = (slug) => ARTICLES.find((a) => a.slug === slug);
export const byCategory = (cat) => ARTICLES.filter((a) => a.category === cat);
